import React, {Component} from 'react';
import './homepage.scss';
import $ from 'jquery';
import API from './../../config/api';
import Tool from './../../utils/tool';
// import {connect} from 'react-redux';
// import {refresh_admin} from './../../redux/models/admin';
import Header from "../../components/Header/header";
import {Toast} from 'antd-mobile';
import AppBtn from "../../components/AppBtn/appBtn";
import TopBtn from "../../components/TopBtn/topBtn";
// import Text from 'react-native/Libraries/Text/Text';

        

// 东城号主页

// @connect(
//   state => ({admin: state.admin}),
//   {refresh_admin}
// )

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topData:{},
      data: [],
      uuid: '',
      name: 'dch',
      dch_id: '', //东城号id
      type: 1,
      loading: false,
      page: 1,
      allDataLoaded: true, //true表示大于20条
    };

  }

  componentWillMount() {
    $('html,body').css({
      'background-color': '#F4F4F4'
    })
    // 获取内容id
    this.getContentId();  
    // 获取内容 
    this.getContent(); //数据流接口
    // 统计
    this.statistics()
    this.ymstatistics()
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);  
  }

  componentWillUnmount() {
    
  }

  // shouldComponentUpdate() {
  //
  // }

  render() {
    const {data, uuid, name, allDataLoaded,topData} = this.state;
    console.log(data)
    return (
      <div className="homepage-box">
        {/*头部*/} 
        <Header name={name} uuid={uuid}/>

        {/*东城号主页头部*/}
        <div className="homepage-head-box"></div>
        <div className="homepage-head">
          <div className='head'>
            <img src={topData.dch_img} className="dch_img"></img>
            <div className='jiav_icon'></div>
            <div className='head_name'>{topData.dch_name}</div>
            {/* <div className='guanzhu'>+ 关注</div> */}
            <AppBtn name={this.state.name} uuid={this.state.uuid} 
              style={{
                width: "auto", 
                height: "auto",
                padding: ".02rem .25rem", 
                position: "absolute",
                right: ".3rem",
                top: ".2rem",
                backgroundColor: "#F04142",
                color: "#fff",
                borderRadius: ".25rem",
                fontSize: ".26rem",
                padding: ".02rem .25rem",
                marginLeft: "0",
                marginTop: "0",
                lineHeight: "normal",
              }} text="+ 关注"/>
          </div>
        </div>
        <div className='desc'>{topData.dch_desc}</div> 

        {/*东城号主页列表*/}
        <div className="homepage-normal-list">
          {
            data.map((item, index) => {
              return (
                <div className="homepage-item" key={index} onClick={this.goDetail.bind(this, item)}>
                  <div className="left">
                    <div className="title">{item.title}</div>
                    <div className="homepage-item-info">
                      <div className="info-left">
                        <div className="time">{Tool.dateFormat_new(item.publish_time)}</div>
                      </div>
                    </div>
                  </div>
                  <div className="right" style={{ backgroundImage: 'url(' + item.cover + ')' }}>
                    {
                      item.type / 1 === 2 ? <div className='video_icon'></div> :  //如果是视频稿件，显示视频图标
                      item.type / 1 === 21 ? <div className='audio_icon'></div> :  //如果是音频稿件，显示音频图标
                      ''
                    }
                  </div>
                </div>
              )
            })
          }
        </div>


        {/*打开APP按钮*/}
        <AppBtn name={this.state.name} uuid={this.state.uuid} style={{marginTop: '.78rem'}} text="打开北京东城App，阅读体验更佳"/>
        
      </div>
    );
  }

  ymstatistics() {
    setTimeout(() => {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl], refererUrl)
      } else {
        console.log('_czc null')
      }
    }, 2000)
  }

  getContentId() {  //获取内容id
    // console.log(this.props);
    const {uuid} = this.props.match.params;
    if (uuid) {
      this.state.uuid = uuid
    } else {
      this.props.history.push('./');
    }
  }

  //数据流接口
  getContent() {
    const { uuid, page } = this.state
    $.ajax({
      type: 'get',
      url: API.homepage,
      async: false,
      headers: {
        version: 'v103'
      },
      data: {
        dch_id: uuid, //东城号id
        page: page,
        need_total_data: 0, //是否需要提取 xxx篇文章 xx热度 xx获赞（该数据查询消耗性能，如不需要请一定传参为 0）0 不需要 1 需要
      },
      dataType: 'json'
    }).done((res) => {
      if (res.code == 0) {
        const newDataLength = res.data.article_info.length; 
        this.setState({   
          topData: res.data.person_info,   
          data: [...this.state.data, ...res.data.article_info],    
          page: this.state.page + 1,    
        });  
        if (newDataLength < 20) { // 检查数据长度是否小于20
          this.setState({ allDataLoaded: false }); // 设置状态为已加载完毕
        }  

        document.title = res.data.person_info.dch_name + '的主页' ;

        this.initWx({
          title: res.data.person_info.dch_name,
          desc: res.data.person_info.dch_desc,
        })
      } else {
        Toast.fail(res.msg || res.error);
      }
    });
  }

  handleScroll = () => {  
    const scrollPosition = window.scrollY;  
    const windowHeight = window.innerHeight;  
    const scrollHeight = document.documentElement.scrollHeight;  
    // if (scrollPosition + windowHeight >= scrollHeight) {  
    //   this.getContent(); // 当滚动到底部时，加载下一页数据  
    // } 
    const scrollBottom = scrollPosition + windowHeight;  
    const scrollDistance = scrollHeight - scrollBottom;  
  
    if (scrollDistance <= 1 && this.state.allDataLoaded) {  // 当滚动到底部时，加载下一页数据  
      this.getContent();   
    }   
  } 
  
  goDetail(item) {
    switch (parseInt(item.type)) {
      case 1:     //图文
        this.props.history.push('/detail/1/' + item.uuid)
        break;
      case 2:     //视频
        this.props.history.push('/detail/2/' + item.uuid + '/2')
        break;
      case 4:     //图说
        this.props.history.push('/detail/3/' + item.uuid)
        break;
      case 6:     //直播
        this.props.history.push('/detail/2/' + item.uuid + '/6')
        break;
      case 21:    //音频
        this.props.history.push('/detail/21/' + item.uuid + '/21')
        break;
    }
  }

  statistics(share) {
    var op = share ? 'share' : 'pv';
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = API.pv + '?xm=bjnews&wz=article_detail&op=' + op + '&pt=web&unique_id=' + this.state.uuid;     //填自己的js路径
    $('body').append(script);
  }

  initWx(obj) {
    //分享
    var wxconfig = new window.WxConfig();
    console.log(window.location.href);
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: API.share_img,
      successCallback: this.statistics.bind(this, true)
    });
  }

}

export default Homepage;


// WEBPACK FOOTER //
// ./src/pages/Homepage/homepage.js